export const getOrderTypeName = (type) => {
  const typeMap = {
    1: "Giao hàng tận nhà",
    2: "Mua tại quầy",
    3: "Đặt trước",
    5: "Đổi quà",
    10: "Xin báo giá",
    12: "Đổi sản phẩm",
    14: "Khách trả lại hàng",
    15: "Hàng chuyển kho",
    16: "Đơn hoàn một phần",
    17: "Đền bù mất hàng",
  };
  return typeMap[type] || type || "-";
};

export const getSaleChannelName = (channelId) => {
  const channelMap = {
    1: "Admin",
    2: "Website",
    10: "API",
    20: "Facebook",
    21: "Instagram",
    41: "Lazada",
    42: "Shopee",
    43: "Sendo",
    45: "Tiki",
    48: "Tiktok Shop",
    49: "Zalo OA",
    50: "Shopee chat",
    51: "Lazada chat",
    52: "Zalo cá nhân",
  };
  return channelMap[channelId] || channelId || "-";
};

export const getStatusText = (status) => {
  const statusMap = {
    40: "Đã đóng gói",
    42: "Đang đóng gói",
    43: "Chờ thu gom",
    54: "Đơn mới",
    55: "Đang xác nhận",
    56: "Đã xác nhận",
    57: "Chờ khách xác nhận",
    58: "Hãng vận chuyển hủy đơn",
    59: "Đang chuyển",
    60: "Thành công",
    61: "Thất bại",
    63: "Khách hủy",
    64: "Hệ thống hủy",
    68: "Hết hàng",
    71: "Đang chuyển hoàn",
    72: "Đã chuyển hoàn",
    73: "Đổi kho xuất hàng",
    74: "Xác nhận hoàn",
  };
  return statusMap[status] || status || "Đơn mới";
};

export const getStatusColor = (status) => {
  const text = getStatusText(status);
  switch (text) {
    case "Đơn mới":
    case "Mới":
    case "Chờ khách xác nhận":
    case "Đang xác nhận":
      return "info";
    case "Đã xác nhận":
    case "Đang đóng gói":
    case "Đã đóng gói":
    case "Đổi kho xuất hàng":
      return "primary";
    case "Chờ thu gom":
    case "Đang chuyển":
    case "Đang vận chuyển":
      return "warning";
    case "Thành công":
      return "success";
    case "Thất bại":
    case "Hãng vận chuyển hủy đơn":
    case "Khách hủy":
    case "Hệ thống hủy":
    case "Hết hàng":
    case "Đang chuyển hoàn":
    case "Đã chuyển hoàn":
    case "Xác nhận hoàn":
    case "Đã hủy":
      return "error";
    default:
      return "default";
  }
};

export const getStatusId = (statusName) => {
  const nameMap = {
    "Đơn mới": 54,
    "Đang xác nhận": 55,
    "Đã xác nhận": 56,
    "Chờ khách xác nhận": 57,
    "Đang đóng gói": 42,
    "Đã đóng gói": 40,
    "Chờ thu gom": 43,
    "Đang chuyển": 59,
    "Thành công": 60,
    "Thất bại": 61,
    "Khách hủy": 63,
    "Hãng vận chuyển hủy đơn": 58,
    "Hệ thống hủy": 64,
    "Hết hàng": 68,
    "Đang chuyển hoàn": 71,
    "Đã chuyển hoàn": 72,
    "Đổi kho xuất hàng": 73,
    "Xác nhận hoàn": 74,
  };
  return nameMap[statusName];
};

